import React, { useEffect } from 'react'
import styled from 'styled-components'
import AOS from "aos";
import "aos/dist/aos.css";

const FooterStyles = styled.footer`
    .footer__container{
        padding: 1rem 0 6rem;
        text-align: center;

        .footer__title{
            font-size: var(--h1-font-size);
            font-weight: var(--font-semi-bold);
            margin-bottom: 1rem;
        }
        .footer__list,.footer__social{
            display: flex;
            justify-content: center;
        }
        .footer__list{
            margin: 2.5rem 0;
            column-gap: 2.5rem;

            .footer__link{
                color: var(--title-color);

                &:hover{
                    text-decoration: underline;
                }
            }
        }
        .footer__social{
            column-gap: 1.25rem;
            .footer__social-link{
                font-size: 1.5rem;
                color: var(--title-color);
                transition: transform 0.3s;

                &:hover{
                    transform: translateY(-0.15rem);
                }
            }
        }
    }
    @media screen and (min-width: 1200px){
        .footer__container{
            padding: 0 0 4rem;

            .footer__list{
                column-gap: 3rem;
                margin: 3rem 0;
            }
            .footer__social{
                column-gap: 2rem;
                .footer__social-link{
                    font-size: 1.5rem;
                }
            }
        }
    }
`
function Footer() {

    useEffect(() => {
        AOS.init({
            duration: 1000,
        });
        AOS.refresh();
    }, [])
    return (
        <FooterStyles>
            <div className="footer__container container">
                <h1 className="footer__title" data-aos="fade-up">𝑺𝒖𝒅𝒉𝒂𝒏𝒔𝒉𝒖</h1>
                <p data-aos="fade-up">Full Stack Web Developer</p>

                <ul className="footer__list" data-aos="fade-up">
                    <li><a href="#home" className="footer__link">Home</a></li>
                    <li><a href="#skills" className="footer__link">Skills</a></li>
                    <li><a href="#projects" className="footer__link">Projects</a></li>
                </ul>

                <ul className="footer__social" data-aos="fade-up-right">
                    <a href="https://www.linkedin.com/in/Sudhanshu894" target='_blank' className="footer__social-link">
                        <i className="ri-linkedin-box-line"></i>
                    </a>
                    <a href="https://github.com/Sudhanshu894" target="_blank" className="footer__social-link">
                        <i className="ri-github-line"></i>
                    </a>
                    <a href="https://codepen.io/Sudhanshu057" target="_blank" className="footer__social-link">
                        <i className="ri-codepen-line"></i>
                    </a>
                </ul>
            </div>
        </FooterStyles>
    )
}

export default Footer